(() => {
  const form = document.getElementById('KitteenWithdrawalForm');
  if (!form) return;
  const key = 'kitteen-withdrawal-pending-v1';
  const labels = { name: 'Prénom et nom', email: 'E-mail', order: 'Numéro de commande', body: 'Déclaration', date: 'Date et heure' };
  const read = () => ({ name: form.elements['contact[name]'].value.trim(), email: form.elements['contact[email]'].value.trim(), order: form.elements['contact[Numéro de commande]'].value.trim() || 'Non précisé', body: form.elements['contact[body]'].value.trim(), date: new Date().toISOString() });
  const display = (target, data) => {
    target.replaceChildren();
    Object.entries(labels).forEach(([field, label]) => {
      const dt = document.createElement('dt'); const dd = document.createElement('dd');
      dt.textContent = label;
      dd.textContent = field === 'date' ? new Date(data.date).toLocaleString('fr-FR', { timeZoneName: 'short' }) : data[field];
      target.append(dt, dd);
    });
  };
  const success = form.querySelector('[data-withdrawal-success]');
  if (success) {
    let data;
    try { data = JSON.parse(sessionStorage.getItem(key)); } catch {}
    if (data && Object.keys(labels).every(field => typeof data[field] === 'string') && Date.now() - Date.parse(data.date) < 3600000 && Date.now() >= Date.parse(data.date)) {
      display(form.querySelector('[data-withdrawal-copy-details]'), data);
      form.querySelector('[data-withdrawal-copy]').hidden = false;
      form.querySelector('[data-withdrawal-download]').addEventListener('click', () => {
        const lines = ['Kitteen — Copie de votre déclaration de rétractation', 'Déclaration transmise par le formulaire en ligne.', 'L’accusé de réception par e-mail sera envoyé par Kitteen dans un délai raisonnable.', '', ...Object.entries(labels).map(([field, label]) => label + ' : ' + data[field]), '', 'Contact : contact@kitteen.com'];
        const url = URL.createObjectURL(new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' }));
        const a = document.createElement('a'); a.href = url; a.download = 'kitteen-declaration-retractation.txt'; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
      });
    }
    try { sessionStorage.removeItem(key); } catch {}
    success.focus();
    return;
  }
  const fields = form.querySelector('[data-withdrawal-fields]');
  const review = form.querySelector('[data-withdrawal-review-panel]');
  const next = form.querySelector('[data-withdrawal-review]');
  const submit = form.querySelector('[data-withdrawal-submit]');
  next.hidden = false; submit.hidden = true;
  next.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    const data = read();
    display(form.querySelector('[data-withdrawal-review-details]'), data);
    fields.hidden = true; review.hidden = false; submit.hidden = false;
    submit.focus();
  });
  form.querySelector('[data-withdrawal-edit]').addEventListener('click', () => {
    fields.hidden = false; review.hidden = true; submit.hidden = true;
    form.elements['contact[name]'].focus();
  });
  form.addEventListener('submit', event => {
    if (review.hidden) {
      event.preventDefault();
      next.click();
      return;
    }
    if (!form.checkValidity()) return;
    const data = read();
    form.querySelector('[data-withdrawal-date]').value = data.date;
    try { sessionStorage.setItem(key, JSON.stringify(data)); } catch {}
  });
})();
